<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9947 16.0605L7.25133 12.3097L8.30922 11.25L10.9947 13.9395L16.6735 8.25L17.7329 9.31125L10.9947 16.0605Z"
      fill="#777FF6"
    />
    <path
      d="M12.4921 1.5C10.419 1.5 8.39254 2.11581 6.66886 3.26957C4.94518 4.42332 3.60173 6.0632 2.80841 7.98182C2.01509 9.90045 1.80752 12.0116 2.21195 14.0484C2.61638 16.0852 3.61465 17.9562 5.08052 19.4246C6.54639 20.8931 8.41403 21.8931 10.4472 22.2982C12.4805 22.7034 14.588 22.4955 16.5032 21.7007C18.4185 20.906 20.0555 19.5602 21.2072 17.8335C22.3589 16.1068 22.9736 14.0767 22.9736 12C22.9736 9.21523 21.8693 6.54451 19.9037 4.57538C17.938 2.60625 15.272 1.5 12.4921 1.5ZM12.4921 21C10.7152 21 8.97819 20.4722 7.50075 19.4832C6.02331 18.4943 4.87178 17.0887 4.19179 15.4442C3.5118 13.7996 3.33388 11.99 3.68054 10.2442C4.0272 8.49836 4.88286 6.89471 6.13932 5.63604C7.39578 4.37737 8.99661 3.5202 10.7394 3.17293C12.4821 2.82567 14.2885 3.0039 15.9302 3.68508C17.5718 4.36627 18.975 5.51983 19.9622 6.99987C20.9494 8.47991 21.4763 10.22 21.4763 12C21.4763 14.3869 20.5297 16.6761 18.8449 18.364C17.16 20.0518 14.8748 21 12.4921 21Z"
      fill="#777FF6"
    />
  </svg>
</template>
<script>
export default {
  name: "CheckCircleIcon",
};
</script>
